import { Button, Col, Form, Input, Row, Typography } from 'antd';
import React, { useEffect } from 'react';

const { Text } = Typography;

function ShortUrlForm(props) {
  const { initialValues, onSubmit, status, type } = props;

  const [form] = Form.useForm();

  useEffect(() => {
    console.log("initialValues: ", initialValues);
    form.setFieldsValue(initialValues);
  }, [initialValues]);

  return (
    <Form
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 14 }}
      onFinish={onSubmit}
      initialValues={initialValues}
      form={form}
    >
      <Form.Item
        label="Name"
        name="name"
        rules={[{ required: true, message: 'Please input Name!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="URL Code"
        name="urlCode"
        rules={[{ required: true, message: 'Please input URL Code!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Destination Link"
        name="longUrl"
        rules={[{ required: true, message: 'Please input destination link!' }]}
      >
        <Input />
      </Form.Item>

      {status.type === 'ERROR' ? (
        <Text type="danger">{status.message}</Text>
      ) : null}
      {status.type === 'SUCCESS' ? (
        <Text type="success">Sucessfully Updated!</Text>
      ) : null}
      <Row justify="end" gutter={12}>
        <Col>
          <Button type="primary" htmlType="submit">
            {type}
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default ShortUrlForm;
